import { useFeatureFlag } from "@app/shared/hooks/use-feature-flag";
import { EidAdhaDecoration } from "./EidAdhaDecoration";
import { EidDecoration } from "./EidDecoration";

/**
 * Festive header strip swap. Adha takes priority over Fitr if both
 * flags somehow ended up on at the same time (they shouldn't — the
 * two Eids are months apart — but explicit priority avoids stacking
 * decorations on top of each other).
 */
export function HeaderTopBar() {
  const isEidAdhaEnabled = useFeatureFlag("eidAdha");
  const isEidFetrEnabled = useFeatureFlag("eidFetr");

  if (isEidAdhaEnabled) return <EidAdhaDecoration />;
  if (isEidFetrEnabled) return <EidDecoration />;

  return null;
}
